import { useMemo } from 'react';

import { ConsignmentLinesTable } from '@/features/consignment-lines-table';
import type { ConsignmentLineItem, ConsignmentStatusCode } from '@/entities/consignments';

import type { PalletGroupView } from '../model/types';
import { PalletUnitsInput } from './pallet-units-input';

interface PalletLinesTableProps {
  consignmentId: string;
  consignmentStatus?: ConsignmentStatusCode;
  isReadOnly?: boolean;
  tableId: string;
  lines: ConsignmentLineItem[];
  selectable: boolean;
  selectedIds: string[];
  onSelectionChange: (ids: string[]) => void;
  /** A pallet's editable units; the unassigned lines have none */
  unitFields?: PalletGroupView['unitFields'];
}

/** One table of the pallet view: the unassigned lines, or a pallet's with their units editable */
export function PalletLinesTable({ lines, unitFields, ...tableProps }: PalletLinesTableProps) {
  const renderInventoryUnits = useMemo(
    () => (unitFields ? (row: ConsignmentLineItem) => <PalletUnitsInput {...unitFields[row.id]} /> : undefined),
    [unitFields]
  );

  return (
    <ConsignmentLinesTable
      {...tableProps}
      data={{ items: lines }}
      isLoading={false}
      renderInventoryUnits={renderInventoryUnits}
    />
  );
}
